type Method = "GET";

export class RequestError extends Error {
  method: Method;
  path: string;
  status: number;

  constructor(method: Method, path: string, status: number) {
    super(`${method} ${path} が失敗しました（${status}）。`);
    this.name = "RequestError";
    this.method = method;
    this.path = path;
    this.status = status;
  }
}
